import { Outlet, useLocation } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'

export function AuthLayout() {
  const { pathname } = useLocation()
  const isClientSetup = pathname === '/client-setup'

  return (
    <div className="relative flex min-h-[100dvh] w-full flex-col items-center p-4 sm:p-6 bg-background">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background"
        aria-hidden="true"
      />

      {/* CHECKPOINT: PRD-10 FR-10.4.3 — Mailbox client guidance uses a wide, responsive setup shell. */}
      <div className={`relative z-10 flex w-full flex-1 flex-col ${isClientSetup ? 'max-w-6xl py-8 sm:py-12' : 'max-w-md justify-center py-8'}`}>
        <div className={`flex items-center justify-center gap-3 ${isClientSetup ? 'mb-10' : 'mb-8'}`}>
          <img src="/logo.svg" alt="PurpleToad Mail" className="h-10 w-10" />
          <span className="text-xl font-bold tracking-tight">PurpleToad Mail</span>
        </div>

        {isClientSetup ? (
          <Outlet />
        ) : (
          <Card className="w-full border-border/50 shadow-2xl">
            <CardContent className="p-6 sm:p-8">
              <Outlet />
            </CardContent>
          </Card>
        )}

        <p className={`text-center text-xs text-muted-foreground ${isClientSetup ? 'mt-10' : 'mt-6'}`}>
          &copy; {new Date().getFullYear()} PurpleToad Mail. All rights reserved.
        </p>
      </div>
    </div>
  )
}
